<template>
  <div class="home">
    <section id="a1">
      <div id="hv"></div>
      <div class="a1-container">
        <GlassCard id="a1-card">
          <template #title>
            <span>Hello!</span>
          </template>
          <template #content>
            <p>I am a full-stack software developer, taking on challenging cutting-edge projects in various fields.</p>
            <p>Crossing different technologies using new and innovative ways in personal, open-source and nation-wide projects.</p>
          </template>
          <template #footer>
            <div class="a1-ft">
              <ScButton @click="jump_next">See More</ScButton>
              <ScButton scto="a2">Contact Me</ScButton>
            </div>
          </template>
        </GlassCard>
      </div>
      <div class="sc-arrows" @click="scr('a2')">
        <div class="sc-arw">
          <img src="../assets/img/scrolldown.svg">
        </div>
        <div class="sc-arw">
          <img src="../assets/img/scrolldown.svg">
        </div>
        <div class="sc-arw">
          <img src="../assets/img/scrolldown.svg">
        </div>
      </div>
    </section>
    <section id="a2">
      <div class="a2-container">
        <div id="contact">
          <div class="cs-title">
            <h2>Preferred method of contact</h2>
          </div>
          <div class="c-panel">
            <ContactCard :data="pr" v-for="pr in pref" :key="pr.title"/>
          </div>
          <div class="cs-title">
            <h2>Other media</h2>
          </div>
          <div class="c-panel">
            <ContactCard :data="pr" v-for="pr in links_other" :key="pr.title"/>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import about_f from 'raw-loader!@/assets/shaders/about1.frag'
import about_v from 'raw-loader!@/assets/shaders/about1.vert'
import about2_f from 'raw-loader!@/assets/shaders/about2.frag'
import about2_v from 'raw-loader!@/assets/shaders/about2.vert'

import { laginter } from '@/utils/magic.js'

import { EffectComposer } from 'three/addons/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/addons/postprocessing/RenderPass.js';
import { TAARenderPass } from 'three/addons/postprocessing/TAARenderPass.js';
import { UnrealBloomPass } from 'three/addons/postprocessing/UnrealBloomPass.js';
import { OutputPass } from 'three/addons/postprocessing/OutputPass.js';

import GlassCard from '@/components/GlassCard.vue';
import ScButton from '@/components/ScButton.vue';
import ContactCard from '@/components/ContactCard.vue';

import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'

export default {
  name: 'HomeView',
  components: {GlassCard, ScButton, ContactCard},
  setup(props) {

    const router = useRouter()
    const route = useRoute()
    const anim = ref(true)
    const scr = (to_id) => {document.getElementById(to_id).scrollIntoView({behavior: 'smooth'})}
    const pref = [
      {
        title: 'Telegram',
        icon: 'https://www.svgrepo.com/show/504946/telegram.svg',
        tag: '@Alex_Dash',
        ln: 'https://t.me/Alex_Dash',
        note: 'Probably the quickest way to reach me'
      },
      {
        title: 'Discord',
        icon: 'https://www.svgrepo.com/show/506463/discord.svg',
        tag: '@axdh',
        note: 'No server invites'
      },
      {
        title: 'Mastodon',
        icon: 'https://www.svgrepo.com/show/521747/mastodon.svg',
        tag: '@alx@tech.lgbt',
        ln: 'https://tech.lgbt/@alx',
        weburl: 'https://tech.lgbt/@alx'
      },
      
    ]
    const links_other = [
      {
        title: 'Website',
        icon: 'https://www.svgrepo.com/show/473990/web.svg',
        weburl: 'https://lxlab.dev'
      },
      {
        title: 'Twitter / X',
        icon: 'https://www.svgrepo.com/show/513008/twitter-154.svg',
        tag: '@imAlexDash',
        ln: 'https://twitter.com/imAlexDash'
      },
      {
        title: 'GitHub',
        icon: 'https://www.svgrepo.com/show/512317/github-142.svg',
        weburl: 'https://github.com/Alex-Dash'
      },
      {
        title: 'Codewars',
        icon: require('@/assets/img/codewars_logo.svg'),
        weburl: 'https://www.codewars.com/users/Alex%20Dash'
      },
      {
        title: 'LeetCode',
        icon: 'https://www.svgrepo.com/show/330828/leetcode.svg',
        weburl: 'https://leetcode.com/u/AlexDash/',
        note: 'Rarely active'
      },
    ]
    const jump_next = () => {
      router.push('/software')
    }
    return {scr, pref, links_other, anim, jump_next}
  },
  async mounted() {
    this.anim = true
    const clock = new THREE.Clock();
    var delta = 0;
    const inter_points_ww = [[400, 1.5], [1100,4], [1600,5], [1800,5]];

    const scene = new THREE.Scene();
    const domel = document.getElementById("hv")
    // window.addEventListener("resize", this.hvresize)
    const camera = new THREE.PerspectiveCamera( 50, domel.scrollWidth / domel.scrollHeight, 0.1, 1000 );
    const renderer = new THREE.WebGLRenderer( {logarithmicDepthBuffer: true });
    renderer.setSize( domel.scrollWidth, domel.scrollHeight );
    domel.appendChild( renderer.domElement );
    window.hv = {camera:camera, renderer:renderer, scene: scene}
    const renderScene = new RenderPass( scene, camera );
    const uniforms = {
      time: {value: 1.0},
      tex: {type: "t", value: new THREE.TextureLoader().load(require('../assets/img/map2.png'))}
    }

    const material = new THREE.ShaderMaterial( {
      uniforms: uniforms,
      vertexShader: about_v,
      fragmentShader: about_f,
      side: THREE.DoubleSide,
      blending: THREE.AdditiveBlending,
      // combine: THREE.MixOperation
      transparent: true,
      depthFunc: THREE.NotEqualDepth
    });
    // material.alphaHash = true;
    // material.blendSrcAlpha = true;
    // material.blendAlpha = 0.001;
    // material.opacity = 0.1;
    // material.shadowSide = THREE.DoubleSide;
    // material.needsUpdate = true;
    // material.depthTest = false;


    const planet = new THREE.Mesh(
       new THREE.SphereGeometry( 2.5, 64, 64 ),
        material
      );
    const pivot = new THREE.Group();
    pivot.add( planet );
    scene.add( pivot );
    pivot.rotation.z = -.34;
    planet.rotation.x = .8;
    const cubeinner = new THREE.Mesh( 
      new THREE.BoxGeometry( 1, 1, 1 ),
      new THREE.ShaderMaterial( {
        uniforms: uniforms,
        vertexShader: about2_v,
        fragmentShader: about2_f,
        side: THREE.DoubleSide,
        blending: THREE.AdditiveBlending,
        // combine: THREE.MixOperation
        transparent: true,
        depthFunc: THREE.NotEqualDepth
      })
    );
    scene.add( cubeinner );
    camera.position.z = 6.5;
    camera.position.x = laginter(domel.clientWidth, inter_points_ww);

    const bloomPass = new UnrealBloomPass( new THREE.Vector2( domel.clientWidth, domel.clientHeight ), 1.5, 0.4, 0.85 );

    bloomPass.threshold = .2;
		bloomPass.strength = .5;
		bloomPass.radius = .4;

    const outputPass = new OutputPass();
    const composer = new EffectComposer( renderer );
		composer.addPass( renderScene );
    const taaRenderPass = new TAARenderPass( scene, camera );
		taaRenderPass.unbiased = false;
    taaRenderPass.sampleLevel = 3;
		composer.addPass( taaRenderPass );
		composer.addPass( bloomPass );
		composer.addPass( outputPass );

    function animate(ctx) {
      if(!ctx.anim){
        return
      }
    	requestAnimationFrame( ()=>{
        animate(ctx)
      } );
      delta = clock.getDelta();
    	planet.rotation.y += 0.1*delta;
      cubeinner.rotation.x += 0.3*delta;
      cubeinner.rotation.y -= 0.3*delta;
      const canvas = renderer.domElement;
      const width = domel.clientWidth;
      const height = domel.clientHeight;
      const needResize = canvas.width !== width || canvas.height !== height;
      if (needResize) {
        renderer.setSize(width, height, false);
        composer.setSize(width, height, false);
        camera.aspect = domel.clientWidth / domel.clientHeight;
        camera.position.x = laginter(domel.clientWidth, inter_points_ww);
        camera.updateProjectionMatrix();
      }

      uniforms[ 'time' ].value = performance.now() / 1000;
    	// renderer.render( scene, camera );
      composer.render();
    }
    renderer.domElement.style = ""

    animate(this);
  },
  unmounted() {
    this.anim = false
  },
  methods: {
  },
}
</script>

<style>
#hv{
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -5;
}

#a1{
  position: relative;
  height: calc(100vh - 3em);
  overflow: hidden;
}

#a2{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  background-image: url('../assets/img/stripes.svg');
  background-repeat: no-repeat;
  background-size: 100%;
  background-attachment: fixed;
  background-position: 0%;
}

.cs-title{
  width: 100%;
  display: flex;
  justify-content: center;
}

.c-panel{
  display: flex;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
}

.c-panel>div{
  margin: 1em; 
}

.sc-arw{
  position: absolute;
  bottom: 0em;
}

.sc-arrows{
  position: absolute;
  display: flex;
  justify-content: center;
  width: 100%;
  bottom: 0;
  cursor: pointer;
}

.sc-arw{
  transform: translate(0em,0em);
  opacity: 0;
  animation: scrollfade 4s cubic-bezier(.74,-0.02,.24,1.01) 0s infinite normal forwards;
}
.sc-arw:nth-child(2){
  animation-delay: 200ms;
  bottom: 1em;
}
.sc-arw:nth-child(3){
  animation-delay: 400ms;
  bottom: 2em;
}

.sc-arrows img{
  width: 4em;
}

.a2-container{
  max-width: 65em;
}

.a1-container{
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

#a1-card{
  max-width: 90vw;
  width: 55em;
  right: 0;
  margin-inline: 8vw;
  height: fit-content;
  margin-bottom: 2em;
}

.a1-ft{
  display: flex;
  justify-content: center;
}
.a1-ft>div{
  margin-inline: 1em;
}

@keyframes scrollfade {
  0%{
    transform: translate(0em,-3em) scale(0.4);
    opacity: 0;
  }
  50%{
    transform: translate(0em, 0em) scale(1);
    opacity: 1;
  }
  90%{
    transform: translate(0em, 3em) scale(0.4);
    opacity: 0;
  }
  100%{
    transform: translate(0em, 3em) scale(0.4);
    opacity: 0;
  }
}
</style>